<tam-dialog tid="userPassword_dialog" class="template-setting-dialog " [opened]="opened" [dialogWidth]="dialogWidth">
    <ng-template #title>
        <span class="dialog-title">Change password</span>
        <smart-icon class="dialog-close dark" name="close" (click)="clickClose()"></smart-icon>
    </ng-template>
    <ng-template #body>
        <div class="bodyContainer">
            <div class="tam-form-field" [ngClass]="{'has-error': oldpassword.invalid}">
                <label class="required">Old password<span class="required-field">*</span></label>
                <input tid="password" [(ngModel)]="oldpasswordvalue" (input)="clickOldPasswordChange()"
                    class="tam-input tam-textbox" type="password" autocomplete="off" [formControl]="oldpassword">
                <div class="tam-form-help" *ngIf="oldpassword.invalid && oldpassword.errors['required']">
                    {{'general.password_required_not_blank_message' | stringLiterals}}
                </div>
                <div class="tam-form-help" *ngIf="oldpassword.errors&&oldpassword.errors['notMatch']">
                    {{'general.password_error_message' | stringLiterals}}
                </div>
            </div>
        </div>
        <div class="tam-form-field" [ngClass]="{'has-error': password.invalid}">
            <label class="required">New password <span class="required-field">*</span></label>
            <input tid="new-password" [(ngModel)]="passwordvalue" (input)="clickNewPasswordChange()"
                class="tam-input tam-textbox" type="password" autocomplete='off' [formControl]="password">
            <div class="tam-form-help" *ngIf="password.invalid && password.errors['required']">
                {{'general.password_required_not_blank_message' | stringLiterals}}
            </div>
        </div>
        <div class="tam-form-field" [ngClass]="{'has-error': confirmedPWD.invalid}">
            <label class="required">Confirm new password<span class="required-field">*</span></label>
            <input tid="confirm_pwd" [(ngModel)]="confirmedPWDvalue" (input)="clickConfirmPasswordChange()"
                class="tam-input tam-textbox" type="password" autocomplete='off' [formControl]="confirmedPWD">
            <div class="tam-form-help" *ngIf="confirmedPWD.invalid && confirmedPWD.errors['required']">
                {{'general.password_required_not_blank_message' | stringLiterals}}
            </div>
            <div class="tam-form-help" *ngIf="confirmedPWD.invalid && confirmedPWD.errors['notMatch']">
                {{'general.newpassword_do_not_match_message' | stringLiterals}}
            </div>
        </div>
    </ng-template>
    <ng-template #footer>
        <div class="footer-container">
            <div class="tam-form-tip">
                <span class="text-tip">You will need to enter your new password when next time login.</span>
                <div>
                    <button tam-button tamType="secondary" tamSize="normal"
                        class="dialog-button dialog-cancel footer-research-button" (click)="clickClose()">
                        Cancel</button>
                    <button tam-button tamType="primary" tamSize="normal"
                        class="dialog-button dialog-publish footer-research-button" (click)="onChangePassword()"
                        [tamLoading]="isProgressing" [disabled]="isProgressing">Change</button>
                </div>
            </div>
        </div>
    </ng-template>
</tam-dialog>
